
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import { sharedState } from '../../../state';
import { getResource, putResource } from '../../../client/resource';
import { Group } from '../../../../../common/framework/model/Group';
import GroupMembers from './GroupMembers.vue';
import SwitchField from '../../../fields/SwitchField.vue';
import SelectField from '../../../fields/SelectField.vue';
import PhoneField from '../../../fields/PhoneField.vue';
import TextField from '../../../fields/TextField.vue';
import EmailField from '../../../fields/EmailField.vue';
import UserGroups from '../users/UserGroups.vue';

@Component({
    components: {
        SwitchField,
        SelectField,
        PhoneField,
        TextField,
        EmailField,
        UserGroups,
        ValidationObserver,
        GroupMembers,
    },
})
export default class EditGroup extends Vue {
    readonly resourceType = 'group';

    @Prop(String) readonly id!: string;

    shared = sharedState;
    local = {
        id: '',
        name: '',
        created: new Date(),
        modified: new Date(),
    };

    async mounted() {
        const row = (await getResource(this.resourceType, this.id))!! as Group;
        Object.assign(this.local, row);
        this.local.name = row.name;
    }

    async save() {
        const row = (await getResource(this.resourceType, this.id))!!;
        await putResource(this.resourceType, this.id, Object.assign(row, this.local));
        this.$router.go(-1);
    }

    back() {
        this.$router.go(-1);
    }
}
